import React from "react";
import { useTranslation } from "react-i18next";
import { Autocomplete } from "../../common/components/Autocomplete";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitleWithCloseButton from "../DialogTitleWithCloseButton";

import styles from "./SearchTeamsModal.module.scss";
import TeamService from "../../service/TeamService";
import { FlattenTeam, Team } from "../../types";
import { Button } from "../../common/components";

interface Props {
  open: boolean;
  onClickClose: () => void;
  onAddToTeam: (teamId: string) => void;
  myTeams: Team[];
}

const SearchTeamsModal = (props: Props) => {
  const { open, onClickClose, onAddToTeam, myTeams } = props;
  const { t } = useTranslation();

  const [selectedTeam, setSelectedTeam] = React.useState<FlattenTeam | null>(
    null
  );

  const onSelection = () => {
    onAddToTeam(selectedTeam?.teamId ?? "");
    onClickClose();
    setSelectedTeam(null);
  };

  const onClose = () => {
    onClickClose();
    setSelectedTeam(null);
  };

  return (
    <Dialog
      open={open}
      className={styles.modal}
      onClose={onClose}
      fullWidth={true}
      maxWidth={"md"}
      classes={{ paper: styles.paper }}
    >
      <DialogTitleWithCloseButton
        id="customized-dialog-title"
        onClose={onClose}
      >
        {t("search.search_team")}
      </DialogTitleWithCloseButton>
      <DialogContent className={styles.content}>
        <div className={styles.container}>
          {/* <div className={styles.switchContainer}>
            <Typography>User</Typography>
            <Switch
              value={searchByProject}
              onChange={(e, checked) => setSearchByProject(checked)}
            />
            <Typography>Project</Typography>
          </div> */}
          <div className={styles.search}>
            <Autocomplete
              id="teamSearchInput"
              value={selectedTeam}
              onChange={(event, newValue) => {
                setSelectedTeam(newValue);
              }}
              apiCall={TeamService.searchTeams}
              // sx={{ minWidth: "100%" }}
              // classes={{ root: { minWidth: "100%" } }}
              // options={allTeams.sort((a, b) => {
              //   const label_a =
              //     a.first_name + " " + a.last_name + " " + a.email;
              //   const label_b =
              //     b.first_name + " " + b.last_name + " " + b.email;
              //   return label_a.localeCompare(label_b);
              // })}
              groupBy={(team) =>
                team?.first_name + " " + team?.last_name + " " + team?.email
              }
              getOptionLabel={(team) =>
                team?.name +
                ",  " +
                team?.first_name +
                " " +
                team?.last_name +
                " " +
                team?.email
              }
              getOptionDisabled={
                (team) => myTeams.some((myTeam) => myTeam?.id === team?.teamId) //Disabled if already joined
              }
              renderOption={(props, team) => {
                return (
                  <li {...props} key={team?.teamId + team?.userId}>
                    {team?.name}
                  </li>
                );
              }}
              label="Grouped by users"
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onSelection} disabled={selectedTeam === null}>
          {t("search.add_to_team")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SearchTeamsModal;
